import * as React from "react";
const SvgFiRrGavel = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-gavel_svg__a)">
      <path
        fill="#062147"
        d="M23.704 10.806a1 1 0 0 0-1.414 0l-.549.549-9.082-9.082.55-.55A1 1 0 1 0 11.793.31l-7 7a.999.999 0 1 0 1.414 1.414l.581-.581 3.827 3.827L.293 22.293a.999.999 0 1 0 1.414 1.414L12.03 13.384l3.841 3.84-.58.58a.999.999 0 1 0 1.414 1.415l7-7a1 1 0 0 0 0-1.414m-9.088 2.337L10.944 9.47l3.042-3.042 3.672 3.672zm-3.37-9.456 1.326 1.327L9.53 8.056 8.203 6.729zm4.785 10.87 3.042-3.042 1.254 1.254-3.042 3.042z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-gavel_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGavel;
